import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AdminServiceService } from 'src/app/services/admin-service.service';
import { ZavicService } from 'src/app/services/zavic.service';
import Swal from 'sweetalert2';


declare var jQuery:any;

@Component({
  selector: 'app-view-zavic',
  templateUrl: './view-zavic.component.html',
  styleUrls: ['styles.css']
})
export class ViewZavicComponent implements OnInit {

  public items=[];
  public questions=[];
  
  
  public zavicForm = this.fb.group({
    title: ['', Validators.required],
    _id:[''],
    opcA: this.fb.group({
      text:['', Validators.required],
      value:[1]
    }) ,
    opcB: this.fb.group({
      text:['', Validators.required],
      value:[1]
    }) ,
    opcC: this.fb.group({
      text:['', Validators.required],
      value:[1]
    }) ,
    opcD: this.fb.group({
      text:['', Validators.required],
      value:[1]
    }) ,
    type: ['', Validators.required],
    order:['', Validators.required],
    index:['']
  });


  constructor(private fb: FormBuilder, private zavicService: ZavicService, private router:Router, private adminService:AdminServiceService) { 

    this.items[0]="";
    this.items[1]="";
    this.items[2]="";
    this.items[3]="";

  }

  ngOnInit(): void {

    this.zavicService.getQuestions().subscribe(
      resp=>{
        this.questions = resp;
      },
      err=>console.log(err)
    )
    
  }


  update(){
    this.zavicForm.get('order').setValue(this.items);
    this.zavicService.updateQuestion(this.zavicForm.value).subscribe(
      resp=>{
        let timerInterval
          Swal.fire({
            title: 'Pregunta actualizada',
            html: '',
            timer: 1000,
            timerProgressBar: true,
            willOpen: () => {
              Swal.showLoading()
            },
            onClose: () => {
              clearInterval(timerInterval)
            }
          }).then((result) => {
            if (result.dismiss === Swal.DismissReason.timer) {
              jQuery("#myModal").modal("hide");
              window.location.reload();
            }
          })
      },
      err=>{
        console.log(err)
      }
    )
  }

  handleEdit(id){
    this.zavicService.getQuestion(id).subscribe(
      resp=>{
        this.zavicForm.get('title').patchValue(resp.title);
        this.zavicForm.get('opcA').patchValue(resp.opcA);
        this.zavicForm.get('opcB').patchValue(resp.opcB);
        this.zavicForm.get('opcC').patchValue(resp.opcC);
        this.zavicForm.get('opcD').patchValue(resp.opcD);
        this.zavicForm.get('type').patchValue(resp.type);
        this.zavicForm.get('_id').patchValue(resp._id);
        this.zavicForm.get('index').patchValue(resp.index);

        this.items = resp.order;
      },
      err=>{

      }
    )
  }

  handleDelete(id){
    var opc = confirm("¿Eliminar pregunta?");
    if (opc==true) this.adminService.deleteQuestion('zavic',id);
  }



}
